import React from 'react'
import { SimpleForm, useEditController, useTranslate, BooleanInput, TextInput, required } from 'react-admin'
import { Grid } from '@mui/material'
import { EditBase } from '../../components/base'
import { FormBottomToolbarWithPermission } from '../../components/form'
import { PARTNER_ICONS_FIELDS, COMMON_FIELDS } from '../../providers/localization/constant'
import { IconImageInput } from '../../components/inputs/IconImageInput'

const ParthnerIconEdit = (props): JSX.Element => {
  const translate = useTranslate()
  // return <span>d</span>

  const { record } = useEditController(props)
  return (
    <EditBase
      // title={`${RESOURCE_PREFIX}.title`}
      encType='multipart/form-data'
      redirect='list'
      listAction={{
        hasShow: false,
        hasBackButton: true,
      }}
    >
      <SimpleForm
        record={{ ...record, encType: 'multipart/form-data' }}
        toolbar={
          <FormBottomToolbarWithPermission encType='multipart/form-data' hasConfirm={true} />
        }
      >
        <TextInput 
          label={translate(`${COMMON_FIELDS}.order`)}
          source='order'
          fullWidth
          validate={[required()]}
        />
        <Grid item>
          <BooleanInput
            color='primary'
            source='is_active'
            label={`${COMMON_FIELDS}.status.label`}
          />
        </Grid>
        <Grid container spacing={2} alignItems='flex-start' justifyContent='center'>
          <Grid item xs={12} sm={6}>
            <IconImageInput
                label={translate(`${PARTNER_ICONS_FIELDS}.icon`)}
                initCrop={false}
                fallbackSource='full_path'
                source='icon'
              />
          </Grid>
        </Grid>
      </SimpleForm>
    </EditBase>
  )
}

export default ParthnerIconEdit
